import { DOCUMENTS_API } from './consts'

export const getAwsImage = (key) => {
  const encodedKey = encodeURIComponent(key)
  return `${DOCUMENTS_API}/images/?key=${encodedKey}`
}

export const getAwsDocuments = (id, type) => {
  if (type === 'default') {
    return `${DOCUMENTS_API}/documents/default/${id}`
  } else if (type === 'new_contract') {
    return `${DOCUMENTS_API}/documents/new_contract/${id}`
  } else {
    return `${DOCUMENTS_API}/documents/${id}`
  }
}
